export const mockAdrList =
  [
    {
      "lineItems": [
        {
          "sku": "01003610",
          "requestedQuantity": 2,
          "grandFatheredPricing": false,
          "name": "LifePak® Nano"
        }
      ],
      "lineItemSkuListList": [
        "01003610"
      ],
      "key": "951544397",
      "value": "ADR#951544397",
      "isPrimaryAdr": true,
      "adrName": "LifePak® Nano"
    },
    {
      "lineItems": [
        {
          "sku": "01003610",
          "requestedQuantity": 2,
          "grandFatheredPricing": false,
          "name": "LifePak® Nano"
        },
        {
          "sku": "01003705",
          "requestedQuantity": 2,
          "grandFatheredPricing": false,
          "name": "Jungamals® SCS"
        }
      ],
      "lineItemSkuListList": [
        "01003610",
        "01003705"
      ],
      "key": "951544364",
      "value": "ADR#951544364",
      "isPrimaryAdr": false,
      "adrName": "LifePak® Nano, Jungamals® SCS"
    }
  ];